import React from 'react'

import ShareButton from '@molecules/ShareButton'
import { useTranslation } from '@models/Translation'

import * as style from './style.module.sass'

type ArticleSnsProps = {
  title: string
}
const ArticleSns: React.FC<ArticleSnsProps> = ({ title }) => {
  const { t } = useTranslation()

  return (
    <div className={style.sns}>
      <div className={style.text}>{t('share.article')}</div>
      <div className={style.icons}>
        <ShareButton name="x" type="bigCircle" text={title} />
        <ShareButton name="linkedin" type="bigCircle" />
        <ShareButton name="facebook" type="bigCircle" />
        <ShareButton name="line" type="bigCircle" />
        <ShareButton name="clipboard" type="bigCircle" />
      </div>
    </div>
  )
}

export default ArticleSns
